import axios from "axios";
import { apiVariable } from "./apiVariable";

export interface PermitRouteCoordinateDto {
  latitude: number;
  longitude: number;
  stepOrder: number;
  label?: string | null;
  pointType?: string | null;
  generatedFallback: boolean;
}

export interface PermitRouteStepMapDto {
  order: number;
  instruction?: string | null;
  state?: string | null;
  maneuver?: string | null;
  roadName?: string | null;
  exit?: string | null;
  distanceMiles?: number | null;
  isBorderStart: boolean;
  isBorderEnd: boolean;
  requiresReview: boolean;
  reviewReason?: string | null;
  coordinate?: PermitRouteCoordinateDto | null;
}

export interface PermitRouteMapDto {
  steps: PermitRouteStepMapDto[];
  points: PermitRouteCoordinateDto[];
  polyline: PermitRouteCoordinateDto[];
  startBorderPoint?: PermitRouteCoordinateDto | null;
  endBorderPoint?: PermitRouteCoordinateDto | null;
  totalDistanceMiles?: number | null;
  stateMileageMiles?: number | null;
  hasFailedSteps: boolean;
  generatedAtUtc: string;
  sourceHash?: string | null;
}

export interface PermitRouteMapRequestDto {
  routeText?: string | null;
  defaultState?: string | null;
  forceRefresh: boolean;
  existingMapData?: PermitRouteMapDto | null;
}

export const generatePermitRouteMap = async (
  request: PermitRouteMapRequestDto,
  token?: string | null,
): Promise<PermitRouteMapDto> => {
  const { data } = await axios.post<PermitRouteMapDto>(
    `${apiVariable}/route-map`,
    request,
    token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : undefined,
  );

  return data;
};
